import { combineReducers } from 'redux';

import {
  FETCH_CONSUMER_FIELD_SCHEMAS,
} from '../actions/index';

const addConsumerFieldSchemas = (state, action) => {
  const { payload: { data: consumerFieldSchemas } } = action;

  return consumerFieldSchemas.reduce((res, field) => {
    return {
      ...res,
      [field.id]: field,
    };
  }, { ...state });
};


const consumerFieldSchemasById = (state = {}, action) => {
  switch (action.type) {
    case FETCH_CONSUMER_FIELD_SCHEMAS:
      return addConsumerFieldSchemas(state, action);
    default:
      return state;
  }
};

export default combineReducers({
  byId: consumerFieldSchemasById,
});



// WEBPACK FOOTER //
// ./src/reducers/consumer-field-schemas.reducer.js